// removed by extract-text-webpack-plugin
module.exports = {"enrichCategoriesCard":"enrichCategoriesCard__oV1hi","enrichCategoryImage":"enrichCategoryImage__jv5Nf","enrichCategoryContent":"enrichCategoryContent__206No","enrichCategoryName":"enrichCategoryName__17uIp"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/enrichCategoryCard/style.css
// module id = fPyE
// module chunks = 323